import { createContext } from 'react';
const NWLContext = createContext();
export default NWLContext;